enum MatchingErrors {
	ANONYMISATION = 'anonymisation',
	SUBMITTING = 'submitting'
}

export { MatchingErrors };
